import { render } from "./DeleteCourseModal.vue?vue&type=template&id=8bf611f2"
import script from "./DeleteCourseModal.vue?vue&type=script&lang=js"
export * from "./DeleteCourseModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__